import React from 'react';
import Grid from '@material-ui/core/Grid';

import ScreenHeader from 'core/components/screen-header';
import useStyles from './header.styles';

const UserProfileHeader = () => {
  const classes = useStyles();

  return (
    <Grid container className={classes.headerWrapper}>
      <Grid className={classes.titleWrapper} container item xs={10}>
        <ScreenHeader title="Profile" options={{ hideBackButton: true }} />
      </Grid>
    </Grid>
  );
};

export default UserProfileHeader;
